const React = require('react');
const { Image, ImageBackground } = require('react-native');

const FastImage = React.forwardRef((props, ref) => {
  const { source, defaultSource, resizeMode, children, style, imageStyle, ...rest } = props;
  const src = source && typeof source === 'object' && source.uri ? source.uri : source;
  const resolvedSource = typeof src === 'string' ? { uri: src } : src;

  if (children) {
    return React.createElement(
      ImageBackground,
      {
        ref,
        source: resolvedSource,
        defaultSource,
        resizeMode: resizeMode || 'cover',
        style,
        imageStyle,
        ...rest,
      },
      children
    );
  }

  return React.createElement(Image, {
    ref,
    source: resolvedSource,
    defaultSource,
    resizeMode: resizeMode || 'cover',
    style,
    ...rest,
  });
});

FastImage.resizeMode = {
  contain: 'contain',
  cover: 'cover',
  stretch: 'stretch',
  center: 'center',
};

FastImage.priority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
};

FastImage.cacheControl = {
  immutable: 'immutable',
  web: 'web',
  cacheOnly: 'cacheOnly',
};

FastImage.preload = () => {};
FastImage.clearMemoryCache = async () => {};
FastImage.clearDiskCache = async () => {};

module.exports = FastImage;
module.exports.default = FastImage;
